import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
  Grid,
  Button,
  Paper,
  TextField,
  Typography,
  Alert,
  Snackbar,
} from '@mui/material';

import { login, setLoginError } from 'redux/actions';
import { checkEmailValid } from 'utils/helper';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '40px',
    textAlign: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px 0 20px',
  },
  input: {
    width: '100%',
    minWidth: '100px',
    maxWidth: '300px',
    marginBottom: '20px',
  },
  loginButton: {
    width: 'fit-content',
    padding: '3px 15px',
    margin: '5px 10px 10px',
    fontSize: '16px',
    backgroundColor: '#5b8d8b',
    borderColor: '#5b8d8b',
    borderRadius: '50px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#48706f',
    },
    '&.Mui-disabled': {
      color: '#fff',
      backgroundColor: '#5b8d8b',
      opacity: '0.6',
    },
  },
  recoverButton: {
    marginTop: '20px',
    fontSize: '1rem',
    fontWeight: '600',
    textTransform: 'none',
  },
}));

const LoginPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user);
  const error = useSelector((state) => state?.error);
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!!user) {
      navigate('/admin');
    }
  }, [user, navigate]);

  useEffect(() => {
    if (error) {
      setShowError(true);
    }
  }, [error]);

  const handleLogin = () => {
    if (!checkEmailValid(email)) {
      return setIsValidEmail(false);
    }
    setIsValidEmail(true);

    const payload = {
      email,
      password,
    };
    dispatch(login(payload));
  };

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <Paper elevation={0} className={classes.paper}>
            <Typography
              sx={{ fontSize: '18px', color: '#888', marginBottom: '30px' }}
            >
              Please enter your email and password to begin.
            </Typography>
            <TextField
              required
              error={!isValidEmail}
              label='Email'
              variant='standard'
              helperText={isValidEmail ? '' : 'Please enter correct email'}
              className={classes.input}
              onChange={(e) => setEmail(e.target.value)}
            ></TextField>
            <TextField
              required
              label='Password'
              type='password'
              variant='standard'
              className={classes.input}
              onChange={(e) => setPassword(e.target.value)}
            ></TextField>
            <Button
              variant='contained'
              className={classes.loginButton}
              disabled={!email || !password}
              onClick={handleLogin}
            >
              Log In
            </Button>
          </Paper>
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
      <Button
        variant='text'
        size='medium'
        className={classes.recoverButton}
        onClick={() => navigate('/forgot-password')}
      >
        Recover Lost Password
      </Button>
      <Snackbar
        open={showError}
        autoHideDuration={6000}
        onClose={() => {
          setShowError(false);
          dispatch(setLoginError(null));
        }}
      >
        <Alert variant='filled' severity='error'>
          {error}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default LoginPage;
